<template>
    <div>
        <pagamento
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            @detalharEtapa="detalharEtapa($event)"
            v-show="mostrarPagamento"
        >
            <template slot="etapaAcoes" slot-scope="data">
                <span v-if="$temAcessoView('SGTEC-UABS-ETP-03')"
                    class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEtapa(data)"
                    ></i>
                </span>
            </template>
        </pagamento>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from '@/app/sgtec/componentes/pagamentos/Pagamento'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        },

        detalharEtapa(etapa) {
            this.$router.push({
                name: 'Sgtec_Uabs_Etapa_Detalhar',
                params: {
                    etapaId: etapa.etapaId,
                    projetoId: etapa.projetoId
                }
            })
        },
    },

    computed: {
        mostrarPagamento() {
            return this.$route.name == 'Sgtec_Uabs_Pagamentos_Detalhar'
        }
    },

    components: {
        Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
